export default {
    extendedSources: 'No additional information has been added to this macro-trend yet.',
    chances: 'No chances have been added to this macro-trend yet.',
    risks: 'No risks have been added to this macro-trend yet.'
}
